module.exports = __webpack_public_path__ + "static/fish-8ce2bc6f04211ae668225fc449abe1ee.svg";